import request from '@/utils/request'
import { requestUS } from '@/utils/usQuotes'

// H5 port: same contract/order endpoints, US contract market type = 2.
export const getUSContracts = page => request({ url: 'vexe/v1/contract/contractList', method: 'get', params: { status: 0, mkt_type: 2, page } })
export const getUSPositionStatus = params => request({ url: 'vexe/v1/contract/positionOperStatus', method: 'get', params })
export const submitUSOrder = (side, data) => request({ url: `vexe/v1/contract_order/${side === 'sell' ? 'sell' : 'buy'}`, method: 'post', data, successMessage: '委托成功' })
export const getUSIndustryStocks = code => request({ url: 'vexe/v1/stock/stockGGHot', method: 'post', data: { code, plate: 601, rank: 1 } })
export const getUSMarketSummary = () => request({ url: 'vexe/v1/stock/gMTodayGs', method: 'get' })
export async function getUSTrades(code) {
  const result = await requestUS('us-trades', { code })
  if (!result || result.code !== 0 || !Array.isArray(result.data && result.data.details)) throw new Error('分时成交返回异常')
  return result.data.details
}
